import { defineStore } from 'pinia'
import { ref } from 'vue'
import { getInfoCategories } from '@/api/system'
import type { InfoCategoryDTO } from '@/types/api'

export const useDictStore = defineStore('dict', () => {
  const debtTypes = ref<InfoCategoryDTO[]>([])
  const dictFetched = ref(false)

  const fetchDebtTypes = async () => {
    if (dictFetched.value) return
    try {
      const res: unknown = await getInfoCategories({ page: 1, size: 100 })
      const data = res as { items?: InfoCategoryDTO[]; list?: InfoCategoryDTO[] } | InfoCategoryDTO[]
      if (data && 'items' in data && data.items) {
        debtTypes.value = data.items
        dictFetched.value = true
      } else if (data && 'list' in data && data.list) {
        debtTypes.value = data.list
        dictFetched.value = true
      } else if (Array.isArray(data)) {
        debtTypes.value = data
        dictFetched.value = true
      }
    } catch {
      // 字典加载失败不阻塞页面，静默处理
    }
  }

  return {
    debtTypes,
    dictFetched,
    fetchDebtTypes
  }
})
